import React, { useState, useEffect, useRef, forwardRef } from "react";
import { Grid } from "@mui/material";
import FormHelperText from "@mui/material/FormHelperText";
import { useSelector, useDispatch } from "react-redux";
import { Form } from "react-final-form";
import * as yup from "yup";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import FormControlLabel from "@mui/material/FormControlLabel";
import { UiInputGroupWr } from "../../../../../../_uiComponents/common/form/UiInputComponents";
import UiInput from "../../../../../../_uiComponents/UiInput";
import UiSwitch from "../../../../../../_uiComponents/common/form/UiSwitch";
import UiCropFileUpload from "../../../../../../_uiComponents/common/form/UiCropFileUpload";
import {
     UiButton,
     UiBackButton,
     UiIconButton,
} from "../../../../../../_uiComponents/common/form/UiButton";
import Validator from "../../../../../../../_helpers/validate.schema";
import PublishedTable from "../PublishedTable";

import {
     incentiveHeaderContentAddRequest,
     incentiveHeaderPublishedRevisionRequest,
} from "../../../../../../../_redux/_actions";

const validateSchema = () =>
     yup.object().shape({
          title: yup.string().required("Header title is required."),
          description: yup.string().required("Header description is required."),
          bannerFileId: yup
               .string()
               .required("Header banner image is required."),
          changeReason: yup.string().required("Change reason is required."),
     });

const onValidate = async (values) => {
     return await Validator(values, validateSchema);
};

export default function CreateHeaderContentForm(props) {
     const [initialValues, setInitialValues] = React.useState({});
     const actionDispatch = useDispatch();
     const cropperRef = useRef();

     useEffect(() => {
          actionDispatch(
               incentiveHeaderPublishedRevisionRequest({
                    campaignId: props.campaignId,
               }),
          );
     }, []);

     const { publishedData, loadHeaderContent, contentHeaderDetails } =
          useSelector((state) => {
               return {
                    publishedData:
                         state.incentive.contentHeaderRevisionPublished,
                    loadHeaderContent: state.incentive.loadHeaderContent,
                    contentHeaderDetails: state.incentive.contentHeaderDetails,
               };
          });

     useEffect(() => {
          if (loadHeaderContent) {
               setInitialValues({
                    title: contentHeaderDetails.Title,
                    description: contentHeaderDetails.Description,
                    changeReason: contentHeaderDetails.Reason,
                    bannerImageUrl: contentHeaderDetails.BannerImageUrl,
                    bannerFileId: contentHeaderDetails.BannerFileId,
               });
          } else {
               // setInitialValues({
               //      title: '',
               //      description:'',
               //      changeReason: '',
               //      bannerImageUrl:'',
               //      bannerFileId: '',
               // });
          }
     }, [loadHeaderContent]);

     const submit = async (values, form) => {
          actionDispatch(
               incentiveHeaderContentAddRequest({
                    ...values,
                    id: props.campaignId,
                    form,
               }),
          );

          setInitialValues(null);
     };

     const formProps = {
          ...(loadHeaderContent && { initialValues: initialValues }),
     };

     return (
          <Form
               initialValues={initialValues}
               onSubmit={submit}
               validate={onValidate}
               mutators={{
                    setFormAttribute: (
                         [fieldName, fieldVal],
                         state,
                         { changeValue },
                    ) => {
                         changeValue(state, fieldName, () => fieldVal);
                    },
               }}
               render={({ form, handleSubmit, ...formValues }) => {
                    return (
                         <form onSubmit={validateSchema}>
                              <div className="sbm-content-section">
                                   <Grid container spacing={2} sx={{ pb: 1 }}>
                                        <Grid
                                             item
                                             xs={12}
                                             lg={6}
                                             sx={{ mt: 1 }}
                                        >
                                             <UiInput
                                                  type="text"
                                                  label="Header Title"
                                                  name="title"
                                             />
                                        </Grid>
                                   </Grid>
                                   <Grid container spacing={2}>
                                        <Grid item xs={12} lg={6}>
                                             <UiInput
                                                  label="Header Description"
                                                  multiline={true}
                                                  minRows={3}
                                                  maxRows={5}
                                                  name="description"
                                             />
                                        </Grid>

                                        <Grid item xs={12} lg={9}>
                                             <UiCropFileUpload
                                                  ref={cropperRef}
                                                  aspectRatio={2 / 1}
                                                  minWidth="120"
                                                  label="Header Banner"
                                                  uploadSize="Min. image size 746px x 350px"
                                                  setUploadValue={(value) => {
                                                       form.mutators.setFormAttribute(
                                                            "bannerFileId",
                                                            value,
                                                       );
                                                  }}
                                                  defaultImage={
                                                       contentHeaderDetails.BannerImageUrl
                                                  }
                                                  setToDefault={
                                                       !loadHeaderContent
                                                  }
                                             />
                                             {form.getState().submitFailed &&
                                                  formValues.errors
                                                       .bannerFileId && (
                                                       <FormHelperText className="sba-form-error">
                                                            {
                                                                 formValues
                                                                      .errors
                                                                      .bannerFileId
                                                            }
                                                       </FormHelperText>
                                                  )}
                                        </Grid>
                                        <Grid
                                             item
                                             xs={12}
                                             lg={6}
                                             className="sba-campaign-content-text-bg"
                                        >
                                             <UiInput
                                                  type="text"
                                                  name="changeReason"
                                                  multiline={true}
                                                  minRows={3}
                                                  maxRows={5}
                                                  label="Change Reason"
                                             />
                                        </Grid>
                                        <Grid
                                             item
                                             xs={12}
                                             lg={12}
                                             sx={{ mb: 2 }}
                                        >
                                             <Stack
                                                  spacing={2}
                                                  direction="row"
                                                  justifyContent="end"
                                                  sx={{ width: "100%" }}
                                             >
                                                  <UiButton
                                                       name="Clear"
                                                       variant="outlined"
                                                       size="small"
                                                       onClick={() => {
                                                            form.restart();
                                                            if (
                                                                 cropperRef.current
                                                            ) {
                                                                 cropperRef.current.reset();
                                                            }
                                                       }}
                                                  />
                                                  <UiButton
                                                       onClick={handleSubmit}
                                                       name="Save"
                                                       variant="contained"
                                                       size="small"
                                                  />
                                             </Stack>
                                        </Grid>
                                        {/* <Grid item xs={12} lg={12}>                       
                                             <div className="sba-revison-publish-table">
                                                  <label class="sba-content-label">Published Revision Content</label>
                                                  <PublishedTable loadData={props.loadHeaderRevisionData} publishedData={publishedData} />
                                             </div>
                                        </Grid> */}
                                   </Grid>
                              </div>
                         </form>
                    );
               }}
          />
     );
}
